<style lang="scss">
@import "../styles/payment/payment-menu-content-form-footer.scss";
</style>

<template>
  <SleekText xs="sleek-body-2" @click.native="onClickBankTransfer"
    >I want a one-time payment through bank-transfer/ cheque.</SleekText
  >
</template>

<script>
// Mappings
import { Constants } from "customer-sdk/constants";

const PAYMENT_METHODS_EVENTS = Constants.ON_BOARDING_PAYMENT_METHODS_EVENTS;
// Components
import SleekText from "@shared-components/presentational/SleekText.vue";

//#region private methods
let publishBankTransferSelected = component => {
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_BANK_TRANSFER_CLICKED,
      data: { selectedCard: "bank_transfer" }
    });
  }
};
//#endregion

export default {
  components: {
    SleekText
  },
  methods: {
    onClickBankTransfer: function() {
      const component = this;
      publishBankTransferSelected(component);
    }
  },
  props: {
    paymentMethodsTopic: Object
  }
};
</script>
